import classNames from 'classnames';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';

// components
import Header from './_Header';
import { Link } from 'react-router';

// higher-order components
import requireUser from '../shared/requireUser';
import TrialsInfo from '../reps/TrialsInfo';
import Trial from '../shared/Trial';

const Rep = ({ children, location }) => {
  const footerActiveClassName = 'rep__footer__link--active';
  const pathname              = location.pathname || '';

  return (
    <div className='rep__layout'>
      <Header>
        <Link activeClassName='header__left__nav__link--active' className='header__left__nav__link' to='/reps/calendar'>
          My Calendar
        </Link>
        <Link activeClassName='header__left__nav__link--active' className='header__left__nav__link' to='/reps/books'>
          Open Books
        </Link>
        <Trial regularComponent={ <Link activeClassName='header__left__nav__link--active' className='header__left__nav__link' to='/reps/premium-subscription'>
                  Premium Subscription
        </Link> } trialComponent={ <Link activeClassName='header__left__nav__link--active' className='header__left__nav__link' to='/reps/trial-subscription'>
                  Trial Subscription
        </Link> } />

        <Link activeClassName='header__left__nav__link--active' className='header__left__nav__link' to='/reps/trade-post'>
              Trade Post
        </Link>
      </Header>
      <TrialsInfo />
      <div className='rep__body'>
        { children }
      </div>
      <nav className='rep__footer'>
        <Link activeClassName='rep__footer__link--active' className='rep__footer__link' to='/reps/calendar'>
          <i className='obmd-calendar' />
        </Link>
        <Link className={ classNames('rep__footer__link', { [`${footerActiveClassName}`]: pathname.match(/\/reps\/books.*/) }) } to='/reps/books'>
          <i className='obmd-books' />
        </Link>
        <Link activeClassName='rep__footer__link--active' className='rep__footer__link' to='/reps/premium-subscription'>
          <i className='obmd-premium-subscription' />
        </Link>
        <Link activeClassName='rep__footer__link--active' className='rep__footer__link' to='/reps/trade-post'>
          <i className='obmd-trades' />
        </Link>
        <Link activeClassName='rep__footer__link--active' className='rep__footer__link' to='/reps/edit'>
          <i className='obmd-settings' />
        </Link>
      </nav>
    </div>
  );
};

Rep.propTypes = {
  routing: PropTypes.instanceOf(Immutable.Map)
};

export default requireUser()(Rep);



// WEBPACK FOOTER //
// ./app/components/layouts/Rep.jsx